import React, { MutableRefObject } from "react";
import ct from "class-types.macro";
import Modal, { Header, Footer, Body } from "~/common/ModalReact";
import Button from "~/common/Buttons";
import { AddToCartModal } from ".";
import { Icon } from "@clarkinc/zest-design-system/ui";
import standardSpritePath from "~/common/Icons/Standard/standard-sprite.svg";

interface Props extends AddToCartModal<"warning"> {
  hasAcknowledgedProductWarning?: MutableRefObject<boolean>;
  setHasAcknowledgedProductWarning?: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  warningContent: string;
}

/**
 * @deprecated Please use `src/features/shopping/ui/modal/ProductWarning` instead.
 */
const ProductWarningModal = ({
  isOpen,
  hasAcknowledgedProductWarning,
  setHasAcknowledgedProductWarning,
  warningContent,
  closeModal,
  submitModal,
}: Props) => {
  const handleAddToCart = async (event: React.SyntheticEvent) => {
    event.preventDefault();

    if (hasAcknowledgedProductWarning) {
      hasAcknowledgedProductWarning.current = true;
    }

    setHasAcknowledgedProductWarning?.(true);

    submitModal({ warning: true });
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      className={`${ct("w-11/12")}" modal--md`}
    >
      <Header closeModal={closeModal}>
        <Icon
          name="attention"
          className="mr-1 w-5 h-5 fill-[#F8A12F]"
          spriteSheetHref={standardSpritePath}
          aria-label="Attention"
        />
        <h3 className={ct("flex", "text-base", "m-0", "ml-3", "md:text-xl")}>
          Please Note!
        </h3>
      </Header>
      <Body className={ct("mt-5")}>
        <div
          className={`${ct("text-sm", "leading-5")}`}
          dangerouslySetInnerHTML={{
            __html: warningContent,
          }}
        />
      </Body>
      <Footer>
        <Button
          className={ct("ml-3")}
          color="blue"
          type="submit"
          onClick={handleAddToCart}
        >
          I Understand
        </Button>
      </Footer>
    </Modal>
  );
};

export default ProductWarningModal;
